import { postAnswers } from 'api/answers/answers.api';
import { FormName, PostAnswersPayload } from 'api/answers/dtos/answers.dto';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export interface Product {
  name: string;
  identification: string;
  value: string;
}

const useConfirmSchoolFeeding = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [sucessModal, setSucessModal] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  // Valores padrão para dados não preenchidos
  const provided = '';
  const applied = '';
  const cnpjProducts: Product[] = [];
  const cpfProducts: Product[] = [];

  const handleSubmit = async () => {
    setLoading(true);
    const userAccessUuid = localStorage.getItem('userAccessUuid') ?? '';
    const institutionUuid = localStorage.getItem('institutionUuid') ?? '';
    const payload: PostAnswersPayload = {
      formName: FormName.ALIMENTACAO_ESCOLAR_MUNICIPAL,
      referencedYear: 2025,
      userAccessUuid,
      institutionUuid,
      answer: {
        valueProvidedByPnae: parseFloat(provided.replace(/[^\d.-]/g, '')) || 0,
        valueAppliedByPnaeResource:
          parseFloat(applied.replace(/[^\d.-]/g, '')) || 0,
        productAquiredFromCnpjByPnaeResourceList: cnpjProducts,
        productAquiredFromCpfByPnaeResourceList: cpfProducts,
      },
    };

    try {
      await postAnswers(payload);
      setSucessModal(true);
    } catch (error) {
      setErrorMessage(
        'Erro ao enviar os dados da Alimentação Escolar (PNAE Estadual).',
      );
    } finally {
      setLoading(false);
    }
  };

  return {
    navigate,
    handleSubmit,
    loading,
    errorMessage,
    sucessModal,
  };
};

export default useConfirmSchoolFeeding;
